import { render, staticRenderFns } from "./EmailPasswordLogin.vue?vue&type=template&id=f72af12e"
import script from "./EmailPasswordLogin.vue?vue&type=script&lang=js"
export * from "./EmailPasswordLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports